import React from "react";

function Filters({
  searchTerm,
  handleSearchChange,
  clearSearch,
  statusFilter,
  handleStatusFilterChange,
}) {
  return (
    <div className="flex flex-col md:flex-row gap-4 mb-6">
      <div className="flex-1 relative">
        <input
          type="text"
          placeholder="Search by name or email"
          value={searchTerm}
          onChange={handleSearchChange}
          className="w-full px-3 py-2 pr-10 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        />
        {searchTerm && (
          <button
            onClick={clearSearch}
            className="absolute right-3 top-1/2 transform -translate-y-1/2 text-gray-400 hover:text-gray-600"
          >
            ✕
          </button>
        )}
      </div>
      <div className="w-full md:w-48">
        <select
          value={statusFilter}
          onChange={handleStatusFilterChange}
          className="w-full px-3 py-2 border border-gray-300 rounded-md focus:outline-none focus:ring-2 focus:ring-blue-500"
        >
          <option value="all">All Users</option>
          <option value="active">Active Users</option>
          <option value="deleted">Deleted Users</option>
        </select>
      </div>
    </div>
  );
}

export default Filters;
